// import { ThumbnailCard } from '.';
// import Slider from 'react-slick';
// import 'slick-carousel/slick/slick.css';
// import 'slick-carousel/slick/slick-theme.css';
import _, { throttle } from 'lodash';
import useInfiniteScroll from 'react-infinite-scroll-hook';
import Loader from '../components/Loader/Loader';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { CARD_COMPONENT_MAP, ThumbnailContainerV2 } from './ThumbnailContainerV2';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import { useIntersection } from 'react-use';

export default function HorizontalHomeCarousel({
  loading,
  hasMore,
  fetchMoreData,
  modelType,
  onEdit,
  data,
  capitalize,
  curatorProp,
  onSuccess,
}) {
  const sliderRef = useRef(null);
  const containerRef = useRef(null);

  const [nextButtonVisible, setNextButtonVisible] = useState(true);
  const lastItemRef = useRef(null);
  const lastItemIntersection = useIntersection(lastItemRef, {
    root: null,
    rootMargin: '0px',
    threshold: 0.5,
  });
  useEffect(() => {
    // show hide next button
    setNextButtonVisible(lastItemIntersection?.intersectionRatio < 0.5);
  }, [lastItemIntersection?.intersectionRatio < 0.5]);

  const [activeIndex, setActiveIndex] = useState(0);

  const [sentryRef] = useInfiniteScroll({
    loading,
    hasNextPage: hasMore,
    onLoadMore: fetchMoreData,
    rootMargin: '0px 0px 120px 120px',
  });

  const scrollSlides = useCallback(
    throttle(
      (deltaX) => {
        if (!sliderRef.current) return;

        if (deltaX > 1) {
          sliderRef.current.slideNext;
        } else if (deltaX < -1) {
          sliderRef.current.slidePrev;
        }
      },
      240,
      { leading: true, trailing: false }
    ),
    []
  );

  useEffect(() => {
    const onWheelSlider = (e) => {
      if (!sliderRef.current) return;

      if (e.deltaX !== 0) {
        // e.preventDefault();
        console.log('e.deltaX: ', e.deltaX);
        scrollSlides(e.deltaX);
      }
    };

    containerRef.current.addEventListener('wheel', onWheelSlider);
    return () => {
      if (!containerRef.current) return;
      containerRef.current.removeEventListener('wheel', onWheelSlider);
    };
  }, []);

  const Component = CARD_COMPONENT_MAP[modelType];

  const items = useMemo(() => {
    const slides = data?.map((item, idx) => {
      if (!Component) {
        // throw new Error('component is not supported')
        return null;
      }

      return (
        <div key={item.id} ref={idx === data.length - 1 ? lastItemRef : undefined}>
          <Component
            key={item.id}
            data={item}
            onEdit={onEdit}
            capitalize={capitalize}
            curatorProp={curatorProp}
            onSuccess={onSuccess}
          />
        </div>
      );
    });

    if (hasMore && slides) {
      slides.push(
        <div className="horizontal-home-carousel-placeholder" key="loader">
          <Loader loading style={{ height: '100%' }} ref={sentryRef} />
        </div>
      );
    }

    return slides || [];
  }, [data, hasMore]);

  return (
    <div ref={containerRef} className={nextButtonVisible ? '' : 'lf-alice-hide-next-button'}>
      <AliceCarousel
        ref={sliderRef}
        activeIndex={activeIndex}
        items={items}
        touchMoveDefaultEvents={false}
        autoWidth={true}
        disableDotsControls={true}
        controlsStrategy="responsive"
        onSlideChanged={(e) => setActiveIndex(e.slide)}
      />
    </div>
  );
}
